module.exports = __webpack_public_path__ + "static/media/home.822de9d1.svg";